import { v4 as uuidv4 } from 'uuid';
import { Export1CView } from '../view/Export1CView';

export const Export1CTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Выгрузка в 1С',
        view: {
            content: <Export1CView plugin={'export_1C_plugin'} />
        }
    }
}